import React from 'react';
import {Button} from "antd";
import classes from "./buttons.module.css";

const RedButton = ({backgroundColor, fontColor, ...props}) => {
    // backgroundColor/fontColor — кастомные пропы, не пробрасываем в DOM (React warning)
    return (
        <Button {...props} className={classes.redBtn}>
            <span>{props.children}</span>
        </Button>
    );
};

RedButton.propTypes = {
    ...Button.propTypes, // Use Ant Design Button propTypes
};

export default RedButton;